module.exports = __webpack_public_path__ + "static/Denture 2 smile after-6eea23908e1b014ffea474edc7a9d599.jpg";